import { Capacitor } from '@capacitor/core';

export const isAndroidCapacitor = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

export const isAndroidTablet = () => {
  if (!isAndroidCapacitor()) {
    return false;
  }
  
  // Check if device is a tablet based on screen size and density
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const pixelRatio = window.devicePixelRatio || 1;
  
  // Calculate physical screen size in inches
  const physicalWidth = screenWidth / (96 * pixelRatio); // 96 DPI is standard
  const physicalHeight = screenHeight / (96 * pixelRatio);
  const diagonalInches = Math.sqrt(physicalWidth * physicalWidth + physicalHeight * physicalHeight);
  
  // Consider device a tablet if diagonal is 7 inches or larger
  // Also check for larger screen dimensions typical of tablets
  return diagonalInches >= 7 || (screenWidth >= 1024 && screenHeight >= 768);
};

export const getCapacitorBottomPadding = () => {
  if (!isAndroidCapacitor()) {
    return 0;
  }

  // Get screen dimensions
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const pixelRatio = window.devicePixelRatio || 1;

  // Calculate physical screen size in inches
  const physicalWidth = screenWidth / (96 * pixelRatio);
  const physicalHeight = screenHeight / (96 * pixelRatio);
  const diagonalInches = Math.sqrt(physicalWidth * physicalWidth + physicalHeight * physicalHeight);

  // Base padding using viewport height (vh) for better screen size accommodation
  let basePadding = 6; // 6vh (was 45px)

  // Increase padding for tablets based on screen size
  if (diagonalInches >= 7) {
    // Tablet - increase padding proportionally to screen size
    const tabletMultiplier = Math.min(diagonalInches / 7, 2.5); // Cap at 2.5x for very large tablets
    basePadding = Math.round(basePadding * tabletMultiplier * 10) / 10; // Round to 1 decimal place
  }

  // Additional padding for very large screens
  if (screenWidth >= 1200 || screenHeight >= 800) {
    basePadding += 3; // 3vh (was 25px)
  }

  return basePadding;
};